<script setup lang="ts">
import { XIcon } from '@heroicons/vue/solid';

const emit = defineEmits(['close']);
</script>

<template>
  <div class="fixed inset-0 z-40 h-svh w-full">
    <div class="fixed inset-0 z-20 h-svh w-full brightness-75 backdrop-blur-sm"></div>
    <div class="relative z-30 grid h-svh grid-cols-[1fr,60px]">
      <div class="relative flex h-full flex-col bg-anti-flash-white">
        <slot name="content" />
      </div>
      <button class="flex h-[60px] items-center justify-center bg-stormcloud p-5 text-white" @click="emit('close')">
        <XIcon class="size-5 stroke-2" />
      </button>
    </div>
  </div>
</template>
